module.exports = __webpack_public_path__ + "img/img7.4e2b1567.jpg";